export const CUSTOM_FILTERS_REDUCER_KEYS = {
  REDUCER: 'customFilters',
  BY_ID: 'byID',
}
